import styled from 'styled-components/macro'

import { Banner, Layout, Icon, Text } from '@loadsmart/miranda-react'
import { toCSSValue } from '@loadsmart/miranda-react/dist/tokens'

type CarrierMenuBannerProps = {
  type: 'loads' | 'shipments'
}

const titleMap: Record<CarrierMenuBannerProps['type'], string> = {
  loads: 'Manage your Loadsmart loads in CarrierGuide.',
  shipments: 'Looking to book or bid with Loadsmart?',
}

const subtitleMap: Record<CarrierMenuBannerProps['type'], string> = {
  loads: 'From February 1st, check, bid, and book using your current email.',
  shipments:
    'Since March 9th, 2026, all Loadsmart brokerage activities are now managed through CarrierGuide.',
}

export function CarrierMenuBanner({ type }: CarrierMenuBannerProps) {
  const fullHref = 'https://app.carrierguide.com/'

  return (
    <Layout.Stack gap="spacing-4">
      <StyledBanner $type={type}>
        <StyledBanner.Icon>
          <Icon name="alert-circle" size="24px" color="color-success-100" />
        </StyledBanner.Icon>
        <StyledBanner.Title style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
          <Text variant="body-md-bold" color="color-text-secondary">
            {titleMap[type]}
          </Text>
          <Text variant="body-md" color="color-text-secondary">
            {subtitleMap[type]}
          </Text>
        </StyledBanner.Title>
        <StyledBanner.Actions style={{ justifyContent: 'center', alignItems: 'center' }}>
          <StyledBanner.ActionPrimary href={fullHref} target="_blank">
            Access CarrierGuide
          </StyledBanner.ActionPrimary>
        </StyledBanner.Actions>
      </StyledBanner>
    </Layout.Stack>
  )
}

const StyledBanner = styled(Banner)<{ $type: CarrierMenuBannerProps['type'] }>`
  width: ${({ $type }) =>
    $type === 'loads' ? `calc(100% - ${toCSSValue('spacing-6')} * 2)` : '100%'};
  margin: ${({ $type }) =>
    $type === 'loads'
      ? `${toCSSValue('spacing-8')} ${toCSSValue('spacing-6')}`
      : `${toCSSValue('spacing-8')} 0`};
  border-radius: ${toCSSValue('spacing-2')};

  --m-banner-background-color: none;
  --m-banner-border: none;

  background: linear-gradient(
    45deg,
    ${toCSSValue('color-brand-accent-1', 0.15)} 23.29%,
    ${toCSSValue('color-brand-accent-2', 0.15)} 88.12%
  );
`
